import { useSelector } from 'react-redux';
import { Box, List, useMediaQuery } from '@mui/material';

import MenuLink from '../MenuLink';
import { getComparator, stableSort } from '../../helpers/utils';
import { FeaturesNames, Orders, Pages } from '../../constants/enums';
import { AdminPermissions } from '../../models/app';
import { useState } from 'react';

interface Props {
  open: boolean;
  closeDrawer: () => void;
}

interface StateProps {
  expanded: string;
  subMenuContent: any;
}

const initialState: StateProps = {
  expanded: '',
  subMenuContent: null,
};

const NavMenu: React.FC<Props> = ({ open, closeDrawer }) => {
  const accountsSelected = useSelector((state: any) => state.accounts.selected);

  const userPermissions: AdminPermissions = useSelector(
    (state: any) => state.app.userPermissions,
  );

  const featuresAllListing = useSelector(
    (state: any) => state.features.listingAll,
  );

  const [state, setState] = useState(initialState);
  const tablet = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const features: any[] = [];
  const featureItems: any[] = [];
  let filtered: any[] = [];

  const handleSetState = (value: any) => {
    setState({ ...state, subMenuContent: value });
  };
  const handleExpanded = (value: any) => {
    setState({ ...state, expanded: value });
  };

  const canViewSettings = (): boolean => {
    return userPermissions.settings;
  };

  if (accountsSelected && accountsSelected.features) {
    filtered = featuresAllListing?.filter(
      (feature: any) => accountsSelected?.features?.indexOf(feature.id) !== -1,
    );
  }
  if (filtered && filtered.length > 0) {
    for (let feature of filtered) {
      if (feature.parent === '-1') {
        features?.push(feature);
      }
    }
  }

  for (let feature of features) {
    if (
      feature.name.toLowerCase() === FeaturesNames.Messaging &&
      userPermissions.Messaging_Access &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.name.toLowerCase() === FeaturesNames.Conversations &&
      userPermissions.Messaging_Access &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.name.toLowerCase() === FeaturesNames.Concept &&
      userPermissions.Concept_Access === true &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.name.toLowerCase() === FeaturesNames.Reservations &&
      userPermissions.Reservations_Access === true &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.name.toLowerCase() === FeaturesNames.Dashboard &&
      userPermissions.dashboard === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.name.toLowerCase() === FeaturesNames.SystemUsers &&
      // userPermissions.settings === true &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else if (
      feature.slug === Pages.CONCEPTS &&
      userPermissions.settings === true &&
      userPermissions.admins === true
    ) {
      featureItems.push({ ...feature, children: [] });
    } else {
      if (
        feature.slug === '#' &&
        feature.name.toLowerCase() === FeaturesNames.Settings &&
        userPermissions.settings === true
      ) {
        const children: any[] = [];
        for (let i = 0; i < filtered.length; i++) {
          if (filtered[i].parent === feature.id) {
            if (filtered[i].name.toLowerCase() === FeaturesNames.AdminGroups) {
              if (userPermissions.admins === true) children.push(filtered[i]);
            } else {
              children.push(filtered[i]);
            }
          }
        }

        featureItems.push({ ...feature, children });
      }
    }
  }
  // console.log({ NavMenuFeatureItems: featureItems });
  return (
    <nav className="main-navigation" style={{ flexGrow: 1 }}>
      <List
        disablePadding
        sx={{
          pt: 2,
          pl: { xs: '12px', md: open && !tablet ? 2 : '6px' },
          pr: { xs: '12px', md: open && !tablet ? 2 : '6px' },
          backgroundColor: 'transparent',
          '&:before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: 60,
            width: '106px',
            height: '1.5px',
            backgroundColor: 'rgba(0, 0, 0, 0.08)',
          },
          textTransform: 'capitalize',
        }}
      >
        {stableSort(featureItems, getComparator(Orders.ASC, 'precedence')).map(
          (feature: any) => (
            <MenuLink
              key={feature.id}
              feature={feature}
              open={open}
              closeDrawer={closeDrawer}
              handleSetState={handleSetState}
              subMenuContent={state.subMenuContent}
              handleExpanded={handleExpanded}
              expanded={state.expanded}
            />
          ),
        )}
      </List>
    </nav>
  );
};

export default NavMenu;
